import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useEvent } from '~/entities/event/model/use-events'
import { ShareLinksCard } from './share-links-card'

export function EventShareLinksCard({ eventId }: { eventId: string }) {
  const { data: business } = useCurrentBusiness()
  const { data: event } = useEvent(business?.id ?? '', eventId)
  if (!business || !event) return null
  return (
    <ShareLinksCard
      businessId={business.id}
      target={{ kind: 'event', id: event.id }}
      title={event.title}
    />
  )
}
